import {observable, action, runInAction} from 'mobx';
import {TechseeBaseController} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-controller';
import {IChatApi} from '../../services/ts-chat-api/ChatApi';

export class TimeoutDialogController extends TechseeBaseController {
    @observable timer: number = 30;
    @observable isVisible: boolean = false;

    private timerId: number | null = null;
    private lastActivityTime: number;

    constructor(private chatApi: IChatApi) {
        super();

        this.lastActivityTime = this.chatApi.lastActivityTime();
    }

    @action
    show() {
        this.timer = 30;
        this.lastActivityTime = this.chatApi.lastActivityTime();
        this.isVisible = true;
        this.startCounting();
    }

    @action
    hide() {
        this.isVisible = false;
        this.cleanup();
    }

    private startCounting(): void {
        this.timerId = window.setInterval(() => {
            if (this.chatApi.lastActivityTime() > this.lastActivityTime) {
                this.cleanup();
                this.keepAlive('yes');
            } else if (this.timer <= 0) {
                this.cleanup();
                this.keepAlive('timeout');
            } else {
                runInAction(() => this.timer--);
            }
        }, 1000);
    }

    @action
    keepAlive(result: 'yes' | 'no' | 'timeout') {
        this.hide();
        if (result === 'yes') {
            this.chatApi.keepSessionAlive();
        } else {
            this.emit('close');
        }
    }

    private cleanup() {
        if (this.timerId !== null) {
            clearInterval(this.timerId);
            this.timerId = null;
        }
    }
}
